import React from 'react';

export function StatusBadge({ status }) {
  const styles = {
    new:      'bg-blue-50 text-blue-700 border border-blue-200',
    reviewed: 'bg-amber-50 text-amber-700 border border-amber-200',
    replied:  'bg-emerald-50 text-emerald-700 border border-emerald-200',
  };

  const labels = {
    new:      'New',
    reviewed: 'Reviewed',
    replied:  'Replied',
  };

  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${styles[status] || styles.new}`}>
      {labels[status] || status}
    </span>
  );
}